import Temp from "@/courier/Temp";

export default class Ninjavan extends Temp {
  static CODE = "NJV";

  constructor() {
    super(Ninjavan.CODE);
  }

  getZone(item) {
    let type;
    let cross_price = 0;
    let remote_area = 0;
    let travel_surcharge = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));
    type = super.checkZone(item.toPostcode);
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      travel_surcharge: travel_surcharge,
      cross_price: cross_price,
    };
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });
    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["NJV"], option).then((res) => {
        let returnRate = {
          isTravelArea: res.data.NJV.is_tourist?40:0,
          isRemote: res.data.NJV.is_remote?50:0
        }
        resolve(returnRate);
      });
    });
  }
}
